import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery } from "../../../../graphql/generated.tsx";
import Loader from "../../../../components/Loader.jsx";
import ReportCampusCard from "../../Components/ReportCampusCard.jsx";

const LeetcodeCampusListing = () => {
  const [campus, setCampus] = useState([]);
  const { data, loading, error } = useGetAllCampusesQuery();
   const [Isload, setIsload] = useState(true);

   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);
  
  useEffect(() => {
    if (data) {
      setCampus(data.allCampus);
    }
  }, [data]);
  if (loading || Isload) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center min-h-screen">
          <Loader />
        </div>
      </AdminLayout>
    );
  }
  return (
    <AdminLayout>
      <div className="p-10">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
            Leetcode Reports
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {campus.map((c) => (
            <ReportCampusCard key={c.id} to={`/admin/reports/leetcode/${c.name}`} name={c.name} />
          ))}
        </div>
      </div>
    </AdminLayout>
  );
};

export default LeetcodeCampusListing;
